import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from "react";
import { Box, Typography, Link, useMediaQuery } from "@material-ui/core";
import { useIntl } from "react-intl";
import { messages } from "../../messages";
import generateDownloadUrl from "../../helpers";
import DescriptionOutlinedIcon from "@material-ui/icons/DescriptionOutlined";
import { clsx } from "clsx";
const OfferSection = ({ setShowEmailSlidein, classes, paymentInfo, applicationNumber }) => {
    const intl = useIntl();
    const getOfferUrl = useCallback(() => {
        return generateDownloadUrl(paymentInfo.Pdf);
    }, [paymentInfo]);
    const isMobile = useMediaQuery("(max-width: 600px)");
    return (_jsx(Box, { className: classes.section, children: _jsxs(Box, { style: {
                display: "flex",
                alignItems: "flex-start",
                justifyContent: isMobile ? "center" : "space-between"
            }, children: [_jsxs(Link, { className: clsx(classes.sectionTitle, classes.sectionTitleunderline), href: getOfferUrl(), target: "_blank", rel: "noopener noreferrer", children: [intl.formatMessage(messages.offerTitle), _jsx(DescriptionOutlinedIcon, { fontSize: "small" })] }), !isMobile && (_jsxs(Box, { style: {
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-end",
                        gap: 8
                    }, children: [_jsx(Typography, { className: classes.link, onClick: () => setShowEmailSlidein(true), children: intl.formatMessage(messages.emailSendCopy) }), paymentInfo?.Pdf && (_jsx(Link, { className: classes.link, href: getOfferUrl(), target: "_blank", rel: "noopener noreferrer", children: intl.formatMessage(messages.offerDownload) }))] }))] }) }));
};
export default OfferSection;
//# sourceMappingURL=OfferSection.js.map